<script>
import Zetrix from "../../utils/zetrix";
import ButtonOutline from "../buttons/buttonOutline.vue";

export default {
  components: {
    ButtonOutline,
  },
  mixins: [Zetrix],
  props: {

  },
  data() {
    return {
      showDialogAccount: false,
      position: "center",
      duration: 1500,
      isCopied: false,
      pending: sessionStorage.getItem("notification"),
      receivedNoti: false,
      buttonName: "Connect Wallet",
      iconPlacement: "prepend",
      buttonIcon: "mdi-wallet-outline",
      snackbar: false,
      showDialogNotification: false,
      isJointExist: false,
    };
  },
  mounted() {
  },
  computed: {
    convertZtx: function () {
      return this.balance / 1000000 + " ZTX";
    },
    isSmallScreen() {
      return this.$vuetify.display.xs;
    },
  },
  watch: {

  },
  created() {
  },
  methods: {
    navigate(path) {
      this.$router.push({ name: path });
    },
    customProcess() {
      this.checkZetrixInstall();
    },
    toLoginZetrix() {
      this.checkZetrixInstall();
    },
    toLogoutZetrix() {
      this.showDialogAccount = false;
      this.disconnectWalletZtx();
    },
    handleCopiedEvent(isCopied) {
      this.isCopied = isCopied;
    },
    shortenUserName(string) {
      const len = string.length;
      if (len > 12) {
        return string.substr(0, 12) + "..." + string.substr(len - 14, len);
      } else {
        return string;
      }
    },
    shortenAddress(address) {
      if (!address) return "";
      const len = address.length;
      if (len <= 10) {
        return address;
      }
      return `${address.substr(0, 6)}...${address.substr(len - 4, 4)}`;
    },
    async copyAddress(text) {
      if (!text) return;

      // Secure context API
      if (window.isSecureContext && navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(text);
          this.snackbar = true;
          return;
        } catch (err) {
          console.error("Clipboard API failed, fallback:", err);
        }
      }

      // Fallback for HTTP / old browsers
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.top = "-9999px";
      document.body.appendChild(ta);

      ta.focus();
      ta.select();
      ta.setSelectionRange(0, ta.value.length);

      let ok = false;
      try {
        ok = document.execCommand("copy");
      } catch (_) {
        ok = false;
      }
      document.body.removeChild(ta);

      this.snackbar = true;
    },
  },
  name: "NavBarKYC",
};
</script>

<template>
  <v-container class="pa-4">
    <v-app-bar :elevation="1" color="white">
      <v-app-bar-title>
        <v-img :width="isSmallScreen ? '128' : '150'" aspect-ratio="16/9" cover
          src="../../assets/images/Zetrix-Logo-small-black.png" class="responsive-img"></v-img>
      </v-app-bar-title>

      <div class="nav-spacer"></div>
      <v-col cols="auto">
        <v-tooltip location="bottom">
          <template #activator="{ props }">
            <!-- If account exists -->
            <ButtonOutline v-if="zetrixAccount !== null" v-bind="props" button-height="40"
              :button-width="isSmallScreen ? '140' : '180'" :button-name="shortenAddress(zetrixAccount)"
              :icon-placement="iconPlacement" :button-icon="buttonIcon" icon-type="image"
              @click="showDialogAccount = true" />

            <!-- If no account -->
            <ButtonOutline v-else v-bind="props" button-height="40" :button-name="buttonName"
              :icon-placement="iconPlacement" :button-icon="buttonIcon" icon-type="icon"
              @customProcess="customProcess" />
          </template>

          <!-- Tooltip text -->
          <span>{{ zetrixAccount || 'No account connected' }}</span>
        </v-tooltip>
      </v-col>

      <div class="nav-spacer"></div>
      <div class="nav-spacer"></div>
    </v-app-bar>
  </v-container>
  <!-- Start Disconnect Dialog -->
  <v-dialog v-model="showDialogAccount" width="450">
    <v-card>
      <v-card-text>
        Your connected wallet address
        <br />
        <b>{{zetrixAccount}}
          <v-icon class="ml-2" @click="copyAddress(zetrixAccount)">
            mdi-content-copy
          </v-icon></b>
        <br />
        <div class="spacer"></div>
        <!-- <div class="d-flex dialog-balance">
          <span>Wallet balance</span>
          <b>{{ balance / 1000000 }} ZETRIX</b>
        </div> -->
        <v-card-actions class="justify-center">
          <ButtonOutline button-width="290" class="disconnect-btn" button-icon="mdi-power" icon-type="icon"
            icon-placement="prepend" button-name="Disconnect" button-size="large" @click="toLogoutZetrix" />
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-snackbar v-model="snackbar" :timeout="2000" :max-width="50">
    Address copied!
  </v-snackbar>
</template>

<style>
.nav-spacer {
  padding-right: 10px;
}

.responsive-img {
  max-width: 100%;
  height: auto;
  cursor: pointer;
}

.v-dialog>.v-overlay__content>.v-card>.v-card-text,
.v-dialog>.v-overlay__content>form>.v-card>.v-card-text {
  padding: 16px 24px 16px 24px;
}

.dialog-balance {
  justify-content: space-between;
}

.disconnect-btn {
  width: 280px;
}

.notification-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.notification-dialog {
  padding-top: 40px;
  display: flex;
  justify-content: end;
  align-items: start;
}
</style>
